import { mapGetters } from 'vuex';


export default {
  ...mapGetters('user', {
    loggedIn: 'isProfileLoaded',
    currentUser: 'currentProfile',
  }),
};
